<template>
  <div class="vr360-textarea"
    :class="{ 'vr360-textarea--error': showErrorMessage,
              'vr360-textarea--centered': isCentered }">
    <textarea class="vr360-text-reg"
              :value="value"
              placeholder=" "
              @input="inputHandler"
              @change="changeHandler">
    </textarea>
    <label>
      <span class="vr360-head-h4 vr360-text-gray-2">{{ placeholder }}</span>
      <p class="vr360-text-caption">{{ errorMessage }}</p>
    </label>
  </div>
</template>

<script>
export default {
  name: 'TextArea',
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      default: 'erroe',
    },
    showErrorMessage: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    isCentered: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  methods: {
    inputHandler(e) {
      let value = e.target.value.trim();
      this.resizeElem(e.target);
      this.$emit('input', value);
    },
    changeHandler(e) {
      let value = e.target.value.trim();
      this.resizeElem(e.target);
      this.$emit('change', value);
    },
    resizeElem(elem) {
      elem.style.height = '';
      elem.style.height = `${elem.scrollHeight}px`;
    }
  },
};
</script>
